// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"FootTC_TheComp__JWH1G"};